module.exports = __webpack_public_path__ + "img/SunDirect.5dc87a07.png";